"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipStatusRequestDTOSchema = exports.MembershipStatusDTO = exports.MembershipStatusDTOSchema = exports.MembershipStatusSchema = exports.MembershipStatusBaseSchema = exports.MEMBERSHIP_STATUS = void 0;
var zod_1 = require("zod");
var Payment_1 = require("./Payment");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var MembershipRate_1 = require("./MembershipRate");
var User_1 = require("./User");
var MEMBERSHIP_STATUS;
(function (MEMBERSHIP_STATUS) {
    MEMBERSHIP_STATUS["UNPAID"] = "Unpaid";
    MEMBERSHIP_STATUS["PENDING"] = "Pending";
    MEMBERSHIP_STATUS["PAID"] = "Paid";
})(MEMBERSHIP_STATUS || (exports.MEMBERSHIP_STATUS = MEMBERSHIP_STATUS = {}));
exports.MembershipStatusBaseSchema = zod_1.z.object({
    MembershipRateId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    // This ones may be optional until finally paid?
    IssueDate: zod_1.z.coerce.date().optional(),
    ExpireDate: zod_1.z.coerce.date().optional(),
    UserId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    // We could add a ref to the payment and / or the actual payment status.
    Status: zod_1.z.nativeEnum(MEMBERSHIP_STATUS).default(MEMBERSHIP_STATUS.UNPAID),
    PaymentId: zod_1.z.instanceof(ObjectId_1.ObjectId).optional(),
    // Track tokens used for discount during upgrade (for non-member upgrades)
    TokensUsedForDiscount: zod_1.z.number().optional(),
});
exports.MembershipStatusSchema = exports.MembershipStatusBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.MembershipStatusDTOSchema = exports.MembershipStatusSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelDTOFields), { MembershipRateId: (0, ObjectId_1.ObjectIdString)('Invalid MembershipRateId'), UserId: (0, ObjectId_1.ObjectIdString)('Invalid UserId'), PaymentId: (0, ObjectId_1.ObjectIdString)('Invalid PaymentId').optional() }));
exports.MembershipStatusDTO = {
    convertFromModel: function (model) {
        var _a, _b, _c;
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            IssueDate: model.IssueDate,
            ExpireDate: model.ExpireDate,
            Status: model.Status,
            MembershipRateId: model.MembershipRateId._id
                ? model.MembershipRateId._id.toString()
                : model.MembershipRateId.toString(),
            MembershipRate: (0, ObjectId_1.isPopulated)(model.MembershipRateId)
                ? MembershipRate_1.MembershipRateDTO.convertFromModel(model.MembershipRateId)
                : undefined,
            UserId: model.UserId._id ? model.UserId._id.toString() : model.UserId.toString(),
            User: (0, ObjectId_1.isPopulated)(model.UserId) ? User_1.UserDTO.convertFromModel(model.UserId) : undefined,
            PaymentId: ((_a = model.PaymentId) === null || _a === void 0 ? void 0 : _a._id) ? (_b = model.PaymentId._id) === null || _b === void 0 ? void 0 : _b.toString() : (_c = model.PaymentId) === null || _c === void 0 ? void 0 : _c.toString(),
            Payment: (0, ObjectId_1.isPopulated)(model.PaymentId) ? Payment_1.PaymentDTO.convertFromModel(model.PaymentId) : undefined,
        };
        return dto;
    },
};
exports.MembershipStatusRequestDTOSchema = exports.MembershipStatusDTOSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelRequestDTOFields), { Status: exports.MembershipStatusDTOSchema.shape.Status.optional() }));
//# sourceMappingURL=MembershipStatus.js.map